import { sessionCreate, sessionInitialUrl, sessionOnCreate, sessionOpen, sessionValidDate } from '../store/session.selectors';
import { SessionCloseRequested, SessionCreateRequested, SessionOpenRequested, VerifyDateRequested } from '../store/session.actions';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/reducers';
import { Router } from '@angular/router';
import { filter, first, switchMap, tap } from 'rxjs/operators';
import { Observable, Subscription } from 'rxjs';

@Component({
	selector: 'start-session',
	templateUrl: './start-session.component.html',
	styleUrls: ['./start-session.component.scss']
})
export class StartSessionComponent implements OnInit, OnDestroy {

	private openSessionSubscription: Subscription;

	validDate$: Observable<boolean>;
	onCreateSession$: Observable<boolean>;
	created$: Observable<boolean>;


	constructor( private store: Store<AppState>, private router: Router ) {
	}

	ngOnInit() {
		this.validDate$ = this.store.select( sessionValidDate );
		this.onCreateSession$ = this.store.select( sessionOnCreate );
		this.created$ = this.store.select( sessionCreate );

		this.store.dispatch( new VerifyDateRequested() );
		this.store.dispatch( new SessionCreateRequested() );

		// Si se pudo crear la sesión => abro la sesión y redirecciono a la URL por defecto
		this.openSessionSubscription = this.store.select( sessionCreate ).pipe(
			filter( created => created ),
			switchMap( () => this.store.select( sessionInitialUrl ) ),
			first(),
			tap( initialUrl => {
				this.router.navigateByUrl( initialUrl, { replaceUrl: true } );
				this.store.dispatch( new SessionOpenRequested() );
			})
		).subscribe();
	}

	onContinuar() {
		this.store.dispatch( new SessionCloseRequested() );
	}

	ngOnDestroy(): void {
		this.openSessionSubscription?.unsubscribe();
	}

}
